import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import config from "../dashboard.config";
import clsx from "clsx";

import LogoWhite from "../icons/LogoWhite";
import LogoWhiteSmall from "../icons/LogoWhiteSmall";
import { Button } from "../components/ui/Button";
import Pushpin from "../icons/Pushpin";
import PushpinFull from "../icons/PushpinFull";
import useConfig from "../hooks/useConfig";
import { CircleX, LayoutDashboard } from "lucide-react";

const Sidebar = ({ sideBarOpen, sideBarToggle, keepOpen, setSideBarOpen, isMobile }) => {
  const { config } = useConfig();
  const [sideBarNav, setSideBarNav] = useState({
    Statistics: {
      icon_normal: <LayoutDashboard className="h-5 w-5 text-gray-400 hover:text-white transition-colors" />,
      icon_active: <LayoutDashboard className="h-5 w-5 text-cyan-400" />,
      status: "active",
      title: "דשבורד",
      href: "/",
    },
  });

  let location = useLocation();

  useEffect(() => {
    let path = location.pathname;
    let nav = {};
    Object.keys(sideBarNav).forEach((item) => {
      if (path === sideBarNav[item].href) {
        nav[item] = sideBarNav[item];
        nav[item].status = "active";
      } else {
        nav[item] = sideBarNav[item];
        nav[item].status = "normal";
      }
    });
    setSideBarNav(nav);
  }, [location]); // eslint-disable-line

  const handleClose = () => {
    setSideBarOpen(false);
  }

  return (
    <div className="relative flex flex-col space-y-4 h-full pt-10">
      <div className="flex w-full justify-end " >
        {isMobile && <Button className="h-6 w-6 bg-transparent" onClick={handleClose} >
          <CircleX />
        </Button>}
      </div>
      {/* <div className="w-full h-16 absolute top-10 "></div> */}
      {/* Logo */}
      <div className="p-4  mb-8 h-10 z-10">
        {
          <div
            className={clsx(
              "transition-all pt-1 absolute top-7 ",
              { "opacity-100 h-5 w-36": sideBarOpen },
              { "opacity-0": !sideBarOpen }
            )}
          >
            <LogoWhite w={"36"} h={"5"} />
          </div>
        }
        {
          <div
            className={clsx(
              "transition-all absolute top-7",
              { "opacity-100": !sideBarOpen },
              { "opacity-0": sideBarOpen }
            )}
          >
            <LogoWhiteSmall w={"8"} h={"auto"} />
          </div>
        }
      </div>
      {/* Items */}
      <div
        className={clsx("flex flex-col h-full justify-between", {
          "pr-4": sideBarOpen,
        })}
      >
        <div className="flex flex-col space-y-4">
          {Object.keys(sideBarNav)
            .filter((el) => !config?.pages || !config.pages[el.toLowerCase()] || config.pages[el.toLowerCase()]["show"])
            .map((item, index) => (
              <Link key={index} to={sideBarNav[item].href}>
                <div
                  className={clsx(
                    "hover:cursor-pointer items-center flex space-x-3 font-medium text-sm p-2 px-5 w-full overflow-hidden h-10",
                    { "rounded-r-full": sideBarOpen },
                    {
                      "bg-gray-800":
                        location.pathname === sideBarNav[item].href,
                    },
                    {
                      "text-gray-300":
                        location.pathname === sideBarNav[item].href,
                    },
                    {
                      "text-gray-500":
                        location.pathname !== sideBarNav[item].href,
                    }
                  )}
                >
                  <div className="">
                    {sideBarNav[item].status === "active"
                      ? sideBarNav[item].icon_active
                      : sideBarNav[item].icon_normal}
                  </div>
                  <div
                    className={clsx(
                      "transition-all whitespace-nowrap",
                      { "opacity-100": sideBarOpen },
                      { "opacity-0 text-xs": !sideBarOpen }
                    )}
                  >
                    {sideBarNav[item].title || item}
                  </div>
                </div>
              </Link>
            ))}
        </div>
        {/* Toggle */}
        <div className="flex flex-col space-y-4">
          <div
            className="text-white p-2 px-5 w-full h-10 cursor-pointer"
            onClick={() => sideBarToggle(!keepOpen)}
          >
            {!keepOpen && <Pushpin />}
            {keepOpen && <PushpinFull />}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Sidebar;
